import { render, staticRenderFns } from "./NewUserModal.vue?vue&type=template&id=1e8ac422&lang=pug&"
import script from "./NewUserModal.vue?vue&type=script&lang=js&"
export * from "./NewUserModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports